module.exports = __webpack_public_path__ + "img/P14b_Matsumi attestation papers_B6268-S049.ee0e52e5.jpg";